import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Dict } from "../types";
import { Injectable } from "@angular/core";
import { CustomerHttpService } from "../generated/customer-http.service";


@Injectable()
export class CustomerOptionsResolver implements Resolve<Dict<string>> {

  constructor(private customerHttpService: CustomerHttpService) {

  }

  async resolve(route: ActivatedRouteSnapshot) {

    const items = await this.customerHttpService.getItems('').toPromise();

    const result: any = {};

    for (let item of items) {
      result[item.id] = item.name + (item.customerCode && item.customerCode.length ? (' [' + item.customerCode + ']') : '');
    }

    return result;
  }

}
